<template>
  <div>
    <Poptip
      transfer
      ref="popover"
      width="220"
      offset="25"
      placement="right-start"
      trigger="hover"
      popper-class="popper-tool-class"
      @on-popper-show="showPop"
    >
      <span class="tool-text">{{rowData[field]}}</span>
      <div slot="content">
        <div class="tool_list">
           <div class="tool_item" v-for="(item, index) in rowData['detail_addtion']" :key="index">
              <div class="tool_name">{{item.tool_name_text}}</div>
              <div class="tool_time">{{item.start_date}}至{{item.end_date}}</div>
           </div>
        </div>
      </div>
    </Poptip>
  </div>
</template>
<script>
export default {
  data() {
    return {}
  },
  props: {
    rowData: Object,
    field: String,
    index: Number
  },
  methods: {
    showPop() {
    //   const bodyHeight = document.body.offsetHeight
    //   const popPosition = document.querySelectorAll('.popper-set-class')[this.index].style.top.split('px')[0] // 当前浮窗top值
    //   if (bodyHeight - popPosition < 334) {
    //     setTimeout(() => {
    //       this.$nextTick(() => {
    //         const topNum = bodyHeight - 364
    //         document.getElementsByClassName('popper-set-class')[this.index].style.top = topNum + 'px' // 设置新top值
    //       }, 200)
    //     }, 0)
    //   }
    }
  }
}
</script>
<style lang="scss">
.tool-text {
  cursor: pointer;
  text-decoration: underline;
  user-select: none;
}
.ivu-poptip-arrow {
  display: none;
}
</style>
<style lang="scss" scoped>
/deep/ .tool_list {
  padding: 10px 0 0 0;
  .tool_item {
    margin-bottom: 10px;
  }
}
/deep/ .ivu-poptip {
  width: 100%;
}
/deep/ .ivu-poptip-rel {
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>
